var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M623.467,264.5H612.32a.821.821,0,0,1-.82-.82v-6.23a.492.492,0,0,1,.984,0v6.066H623.3V245.484h-10.82v6.066a.492.492,0,0,1-.984,0V245.32a.821.821,0,0,1,.82-.82h11.148a.821.821,0,0,1,.82.82V263.68A.821.821,0,0,1,623.467,264.5Z",
    transform: "translate(-611.5 -244.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.574)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.762,274.484H589.992a.492.492,0,1,1,0-.984h13.771a.492.492,0,0,1,0,.984Z",
    transform: "translate(-589.5 -273.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.926,270.353a.49.49,0,0,1-.348-.144l-3.934-3.934a.492.492,0,0,1,0-.7l3.934-3.934a.492.492,0,0,1,.7.7l-3.587,3.587,3.587,3.587a.492.492,0,0,1-.348.84Z",
    transform: "translate(-589.5 -261.5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.d39866026a333c6a8d514abeba443c87.svg";
export { ForwardRef as ReactComponent };